import { AbilityBuilder } from "@casl/ability";
import { AppAbility } from "modules/auth";

export const defineRulesForMinistryOfficial = (abilityBuilder: AbilityBuilder<AppAbility>) => {
    const { can, cannot, rules } = abilityBuilder;

    cannot("view", "UserActivityModule");
    cannot("view", "UserAdministrationModule");
    cannot("view", "ModulesAdministrationModule");
    cannot("view", "CommunicationModule");
    can("view", "UserNotificationsModule");

    can("view", "InternalSystemsModule");
    can("view", "ExternalModules");
    can("view", "AdditionalModules");
    cannot("view", "EducationAnalysis");
    can("view", "SemisAdministrationModule");
    can("view", "SEMIS");
    can("view", "InternalDocumentation");
    can("view", "PIO");
    can("view", "Webtop");
    can("view", "ReportProblem");

    can("view", "Records");
    cannot("update", "Records");

    cannot("view", "EducationModule");
    cannot("view", "EducationLinks");
    cannot("view", "EducationDocuments");
    cannot("update", "EducationDocuments");

    cannot("view", "CourseList");
    cannot("view", "FarmList");
    cannot("update", "UserRole");

    can("view", "WeatherAlarmToggle");

    cannot("view", "Beekeeping");
    cannot("update", "Beekeeping");

    return rules;
};
